import { FC } from 'react';

import { Grid } from '@mui/material';

import TableList from 'src/components/TableList/TableList';
import { HISTORY_TABLE_HEADERS } from 'src/constants';

interface HistoryProps {
    isMerchant?: boolean;
    auditLogs?: {
        id: number;
        activityType: string;
        createdAt: string;
        user: {
            firstName: string;
            lastName: string;
        };
    }[];
    isDashboardTable?: boolean;
    isHistoryTable?: boolean;
    isTableModal?: boolean;
}

const History: FC<HistoryProps> = ({
    auditLogs,
    isTableModal = true,
    isDashboardTable = true,
    isHistoryTable = true,
}) => {
    const tableData = auditLogs?.map((log) => {
        return {
            id: log.id,
            description: log.activityType,
            dateCreated: log.createdAt,
            createdBy: log?.user ? `${log?.user?.firstName} ${log?.user?.lastName} ` : `System`,
        };
    });

    return (
        <Grid sx={{ display: 'flex', flexDirection: 'column', maxWidth: '100%' }}>
            <TableList
                isTableModal={isTableModal}
                isDashboardTable={isDashboardTable}
                isHistoryTable={isHistoryTable}
                data={tableData}
                headers={HISTORY_TABLE_HEADERS}
            />
        </Grid>
    );
};

export default History;
